import { enableES5 } from "immer";
import app, { AppState } from "./app/appReducer";
import forms, { FormState } from "./form/formReducer";

enableES5();

export interface State {
	app: AppState;
	forms: FormState;
}

export { app, forms };
